import { render, staticRenderFns } from "./ipt-textarea.vue?vue&type=template&id=45f970c2&scoped=true&"
import script from "./ipt-textarea.vue?vue&type=script&lang=ts&"
export * from "./ipt-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-textarea.vue?vue&type=style&index=0&id=45f970c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f970c2",
  null
  
)

export default component.exports